import PropTypes from 'prop-types';
import React from 'react';
import {home} from 'src/shared/pagePaths';
import {
  button,
  buttonGroup,
  primary,
} from 'src/styles/modules/button.module.scss';
import StatusCheck from 'src/svgs/status/check.svg';
import {header} from '../header.module.scss';
import {icon} from './style.module.scss';

export const CallCancelledView = ({
  continueUrl,
  onComplete,
  onSupport,
}) => {
  return (
    <>
      <header className={header}>
        <StatusCheck className={icon} />
        <h1>Your callback has been cancelled.</h1>
        <p>Still need help? Try visiting our Support page.</p>
      </header>
      <div className={buttonGroup}>
        <a className={`${button} ${primary}`} href={continueUrl} onClick={onComplete}>Thanks, I&apos;m Done</a>
        <a className={button} onClick={onSupport} href={home()}>Go to Support</a>
      </div>
    </>
  );
};

CallCancelledView.propTypes = {
  continueUrl: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired,
  onSupport: PropTypes.func.isRequired,
};
